module.exports = __webpack_public_path__ + "static/img/product_1.a7d545d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/product_1.png
// module id = 2rAh
// module chunks = 15